import { SessionHead } from './types.js';

export function getHashTags(head: SessionHead): string[] {
  const regexp = /(?:^|\s)(#[a-zA-Z0-9_-]+)(?=$|[^a-zA-Z0-9_-])/g;
  const titleTagsIt = head.title.matchAll(regexp);
  const descTagsIt = head.description.matchAll(regexp);
  return [...titleTagsIt, ...descTagsIt].map(m => m[1]);
}
